<template>
  <div class="ei-indicator">
    <svg class="svg" xmlns="http://www.w3.org/2000/svg" width="68.287" height="66.373" viewBox="0 0 214 208">
      <path id="cls-1" :class="{'cls-1':true,'animated':animated}" stroke-dasharray="545,545" stroke-dashoffset="545px"
            d="M63,29h90a29.987,29.987,0,0,1,29.992,30c-0.024,30-.12,60-0.5,90-0.242,16.569-13.674,30-30,30h-89.5A30,30,0,0,1,33,149V59A30,30,0,0,1,63,29h0Z"/>
      <path id="cls-2" :class="{'cls-2':true,'animated':animated}" stroke-dasharray="545,545" stroke-dashoffset="545px"
            d="M129.213,19.147l63.64,63.64a30,30,0,0,1,0,42.426l-63.64,63.64a30,30,0,0,1-42.426,0l-63.64-63.64a30,30,0,0,1,0-42.426l63.64-63.64A30,30,0,0,1,129.213,19.147Z"/>
    </svg>
    <div class="index">
      <span class="order">{{ order }}</span>
      <span class="split"></span>
      <span class="total">{{ total }}</span>
    </div>
    <!--        <button @click="test"> 123 </button>-->
  </div>
</template>

<script>
export default {
  name: 'EiIndicator',
  props: {
    order: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    animated: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    //正确给 Data 赋值的 方法
    animated: function (newVal, oldVal) {
      this.$set(this, 'animated', newVal)
    }
  },
  methods: {
    test () {
      this.$set(this, 'animated', false)
      setTimeout(() => {
        this.$set(this, 'animated', true)
      }, 100)

    }
  }
}
</script>

<style scoped lang="scss">
.ei-indicator {
  display: inline-block;
  position: relative;
  width: 70px;
  height: 70px;
  vertical-align: middle;
  .svg {
    position: absolute;
    // 尺寸放入 CSS 以便随视口缩放（与 SVG 属性 68.287x66.373 等值）
    width: 68.287px;
    height: 66.373px;
    .cls-1, .cls-2 {
      fill: none;
      stroke: #fff;
      stroke-linecap: round;
      stroke-linejoin: round;
      fill-rule: evenodd;
    }

    .cls-1, .cls-2 {
      stroke-width: 6px;

      &.animated {
        animation: time 5s ease infinite;
      }

    }
  }

  .index {
    position: absolute;
    width: 70px;
    height: 70px;
    text-align: center;
    display: inline-block;
    line-height: 1.2;
    vertical-align: middle;
    margin-top: 7px;
    color: #fff;

    .order {
      display: block;
      height: 10px;
      margin-top: 8px;
      margin-bottom: 3px;
      font-size: 14px;
    }

    .split{
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 20px;
      height: 5px;
      border-bottom: 1px solid #ffffff;
    }

    .total {
      display: block;
      margin-top: 2px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
    }

  }
}

@keyframes time {
  0%{stroke: white;stroke-dashoffset: 545px;opacity: 0}
  7%{ stroke: #ff3300;}
  14%{stroke: #ff8c00;}
  21%{stroke: #ffd500;}
  28%{stroke: #59ff00;}
  35%{stroke: #00ffd9;}
  42%{stroke: #967eff;}
  49%{stroke: #d000ff;}
  50%{opacity: 1}
  56%{stroke: #ff006f;}
  63%{stroke: #ff2600;}
  70%{stroke: #ffb700;}
  77%{stroke: #fff200;}
  80%{stroke: #0fff00;}
  87%{stroke: #00ffcc;}
  94%{stroke: #0088ff;}
  100%{stroke: #e600ff;stroke-dashoffset: 0;opacity: 0.5}
}

* img,span,a,div{
  user-select: none;
  -webkit-user-drag:none;
}
</style>
